// TODO: доделать и проверить
import axios from 'axios';

var conf = {};

export function token() {
    return localStorage.getItem('imms_token');
}

function headers() {
    return {
        Authorization: "Bearer " + token()
    };
}

export function initialize(config) {
    Object.assign(conf, config);
}

export function getConfig() {
    return conf;
}

// Users

export async function login(loginData) {
    return new Promise((resolve, reject) => {
        axios.post(`${conf.api_url}/auth/signin`, {
            data: loginData
        })
            .then((response) => {
                // if (response.status >= 200 && response.status < 300) {
                //     localStorage.setItem('imms_token', response.data.data.token);
                //     localStorage.setItem('imms_login', response.data.data.login);

                //     resolve(response.data.data);
                // }
                // else {
                //     reject(response.data.data.message);
                // }
                // console.log(response.data.data);
                localStorage.setItem('imms_token', response.data.data.token);
                localStorage.setItem('imms_login', response.data.data.login);
                localStorage.setItem('imms_id', response.data.data.id);

                resolve(response.data.data);
            })
            .catch((err) => {
                if (err.response) {
                    reject(err.response.data.error);
                } else {
                    reject(err)
                }
            });
    });
}

export function updateUser(id, item) {
    return axios.put(
        `${conf.api_url}/users/${id}`,
        { data: item },
        { headers: headers() }
    );
}

export function signupUser(item) {
    return axios.post(
        `${conf.api_url}/auth/signup`,
        { data: item },
        { headers: headers() }
    );
}

export function hasToken() {
    return localStorage.getItem('imms_token') !== null;
}

export function isLogined() {
    return hasToken();
}

export function logout() {
    localStorage.removeItem("imms_login");
    localStorage.removeItem("imms_token");

    window.location.reload();
}

export function getUserDetails(id) {
    return axios.get(
        `${conf.api_url}/users/${id}`, {
        headers: headers()
    })
}

export function getUsers() {
    return axios.get(`${conf.api_url}/users`, { headers: headers() })
}

export function getUsersDictionary() {
    return axios.get(`${conf.api_url}/users?scheme=dictionary`, { headers: headers() })
}

export function removeUser(id) {
    return axios.delete(
        `${conf.api_url}/users/${id}`,
        { headers: headers() }
    )
}

export function getUserRolesDictionary() {
    return axios.get(`${conf.api_url}/roles?scheme=dictionary`, { headers: headers() })
}

// TODO: снести этот метод!
export function isUserAdmin() {
    return true;
}

export function updateUserProfile(id, item) {
    return axios.put(
        `${conf.api_url}/auth/profile/${id}`,
        { data: item },
        { headers: headers() }
    );
}

export async function makeRequest(requestPromise) {
    return new Promise((resolve, reject) => {
        requestPromise.then(
            (response) => {
                if (response.status >= 200 && response.status < 300) {
                    resolve(response);
                } else {
                    reject(response.data);
                }
            })
            .catch((err) => {
                if (err.response) {
                    // если токена нет или он недействителен - сделаем выход из системы
                    if (err.response.status === 401 && err.response.data.error.codeName === 'AuthenticationTokenError') {
                        logout();
                    } else {
                        // console.log(err.response.data.error);
                        reject(err.response.data.error.message);
                    }
                } else {
                    reject(err)
                }
            });
    });
}

// Display

export function getDisplays() {
    return axios.get(conf.api_url + '/devices', { headers: headers() })
    // return axios.get(conf.api_url + 'displays/get')
}

export function getDisplaysDictionary() {
    return axios.get(conf.api_url + '/devices?scheme=dictionary', { headers: headers() })
}

export function getEnabledDisplays() {
    return axios.get(conf.api_url + '/devices?filter=enabled', { headers: headers() })
}

// export function searchDisplays(value) {
//     return axios.get(
//         conf.api_url + 'displays/search', {
//         params: {
//             value: value
//         },
//         headers: {
//             Authorization: "Bearer " + token()
//         }
//     });
// }

export function getDisplayDetails(id) {
    return axios.get(
        `${conf.api_url}/devices/${id}`, {
        headers: headers()
    })
}

// export function saveDisplayData(id, item) {
//     return axios.post(
//         conf.api_url + 'displays/save-details', JSON.stringify({
//             id: id,
//             data: item
//         }), { headers: { 
//         "Content-Type": "application/x-www-form-urlencoded"
//     } })
// }

export function saveDisplayData(id, item) {
    if (id === 0) {
        return axios.post(
            `${conf.api_url}/devices/`,
            { data: item },
            { headers: headers() }
        );
    } else {
        return axios.put(
            `${conf.api_url}/devices/${id}`,
            { data: item },
            { headers: headers() }
        );
    }
}

// export function saveDisplaySettings(item) {
//     return axios.post(
//         conf.api_url + 'displays/save-settings',
//         querystring.stringify(item),
//         { headers: headers() }
//     )
// }

// export function getDisplaySettings(id) {
//     return axios.get(
//         conf.api_url + 'displays/get-settings', {
//         params: {
//             id: id
//         },
//         headers: headers()
//     })
// }

export function removeDisplay(id) {
    return axios.delete(
        `${conf.api_url}/devices/${id}`,
        { headers: headers() }
    )
}

export function runDisplayCommand(displayId, command) {
    return axios.post(
        `${conf.api_url}/devices/${displayId}/command`, {
        data: {
            command
        }
    },
        // querystring.stringify({
        //     displayId: displayId,
        //     command: command
        // }),
        { headers: headers() }
    )
}

// export function getSettingsFromDevice(displayData) {
//     return axios.get(
//         conf.api_url + 'displays/get-settings-from-device', {
//         params: {
//             ipAddress: displayData.ipAddress,
//             port: displayData.port
//         },
//         headers: {
//             Authorization: "Bearer " + token()
//         }
//     }
//     )
// }

//Checkpoint

export function getCheckpoints() {
    return axios.get(`${conf.api_url}/checkpoints`, { headers: headers() })
}

export function getCheckpointsDictionary() {
    return axios.get(`${conf.api_url}/checkpoints?scheme=dictionary`, { headers: headers() })
}

export function getCheckpointDetails(id) {
    return axios.get(`${conf.api_url}/checkpoints/${id}`, { headers: headers() })
}

// export function searchCheckpoints(value) {
//     return axios.get(
//         conf.api_url + 'checkpoints/search', {
//         params: {
//             value: value
//         },
//         headers: {
//             Authorization: "Bearer " + token()
//         }
//     });
// }

export function saveCheckpoint(id, item) {
    if (id === 0) {
        return axios.post(
            `${conf.api_url}/checkpoints/`,
            { data: item },
            { headers: headers() }
        );
    } else {
        return axios.put(
            `${conf.api_url}/checkpoints/${id}`,
            { data: item },
            { headers: headers() }
        );
    }
}

export function removeCheckpoint(id) {
    return axios.delete(
        `${conf.api_url}/checkpoint/${id}`,
        { headers: headers() }
    )
}

// export function runCheckpointsImport(rewriteExistItems) {
//     return axios.post(`${conf.api_url}/checkpoints/import`, { headers: headers() });
// }

export function runCheckpointsImport(rewriteExistItems) {
    return axios.post(
        `${conf.api_url}/checkpoints/import`, {},
        { headers: headers() }
    )
}

// Log

// export function getLogs(from, count) {
//     return axios.get(
//         conf.api_url + 'logs/get', {
//         params: {
//             from: from,
//             count: count
//         },
//         headers: {
//             Authorization: "Bearer " + token()
//         }
//     });
// }

export function getFilteredLogs(filterOptions) {
    return axios.get(
        `${conf.api_url}/logs`, {
        params: filterOptions,
        headers: {
            Authorization: "Bearer " + token()
        }
    });
}

export function getUserDeviceActions(options) {
    return axios.get(
        `${conf.api_url}/logs/device-actions`, {
        params: options,
        headers: {
            Authorization: "Bearer " + token()
        }
    });
}

// export function getLogsForDisplay(displayId) {
//     return axios.get(
//         conf.api_url + 'logs/get-for-display', {
//         params: {
//             displayId: displayId
//         },
//         headers: {
//             Authorization: "Bearer " + token()
//         }
//     });
// }

export function getReport(rawOptions) {
    const options = {
        devices: rawOptions.displays_id,
        from: rawOptions.from,
        to: rawOptions.to,
    };
    return axios.get(
        `${conf.api_url}/logs/report`, {
        params: options,
        headers: {
            Authorization: "Bearer " + token()
        }
    });
}

// Custom content files

export function getCustomContentFiles() {
    return axios.get(
        `${conf.api_url}/mediafiles`, { headers: headers() })
}

export function getCustomContentFileDetails(id) {
    return axios.get(
        `${conf.api_url}/mediafiles/${id}`, {
        headers: headers()
    })
}

export function getCustomContentFileAssignment(id) {
    return axios.get(
        `${conf.api_url}/mediafiles/${id}/assignment`, {
        headers: headers()
    })
}

export function saveCustomContentFile(item) {
    return axios.post(
        `${conf.api_url}/mediafiles`,
        item,
        {
            headers: {
                Authorization: "Bearer " + token(),
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

export function editCustomContentFileAssignment(id, data) {
    return axios.put(
        `${conf.api_url}/mediafiles/${id}/assignment`, data,
        { headers: headers() }
    )
}

export function removeCustomContentFile(id) {
    return axios.delete(
        `${conf.api_url}/mediafiles/${id}`,
        { headers: headers() }
    )
}

export function showCustomContent(id, data) {
    return axios.post(
        `${conf.api_url}/mediafiles/${id}/show`, {
        data: {
            devices: data.displayIds,
            duration: data.duration,
        }
    },
        { headers: headers() }
    )
}

// Settings editor

export function getDeviceSettings(id) {
    return axios.get(
        `${conf.api_url}/devices/${id}/settings`, {
        headers: headers()
    })
}

export function saveDeviceSettings(id, data) {
    return axios.put(
        `${conf.api_url}/devices/${id}/settings`, {
        data
    },
        { headers: headers() }
    )
}

// Device groups

export function getDeviceGroups(deviceIds) {
    return axios.get(
        conf.api_url + 'device-groups/get', {
        params: {
            deviceIds: deviceIds
        },
        headers: headers()
    })
}

// export function getDeviceGroupDetails(id) {
//     return axios.get(
//         conf.api_url + 'device-groups/get-details', {
//         params: {
//             id: id
//         },
//         headers: headers()
//     })
// }

// export function saveDeviceGroup(data) {
//     return axios.post(
//         conf.api_url + 'device-groups/save', {
//         item: data
//     },
//         { headers: headers() }
//     )
// }

// export function removeDeviceGroup(id) {
//     return axios.post(
//         conf.api_url + 'device-groups/remove', {
//         id: id
//     },
//         { headers: headers() }
//     )
// }

export function getServerVersion() {
    return axios.get(
        `${conf.api_url}/services/version`, {
        headers: headers()
    })
}